$(document).ready(function() {
  $('.accordion_btn').click(function () {
    // $('.accordion_btn').removeClass('active');
    if($(this).hasClass('active')) {
      $(this).next().slideUp();
      $(this).removeClass('active');
    } else {
      $(this).next().slideDown();
      $(this).addClass('active');
    }
  });
});


$(document).ready(function() {
  $(document).on('click','.product-size_variant_tabs .tab', function(e){
    e.preventDefault();
    var targetElement = $(this).attr('data-toggle-target');
    $('.product-size_variant_tabs .tab').removeClass('active');
    $(this).addClass('active');
    $('.block-swatch span').hide();
    $(`.block-swatch .${targetElement}`).show();
  });
});